import React from 'react';

interface TextAreaProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  helpText?: string;
  rows?: number;
  maxLength?: number;
  showCharCount?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  helpText,
  rows = 4,
  maxLength,
  showCharCount = false,
}) => {
  const charCount = value.length;
  const showCount = showCharCount || maxLength;

  return (
    <div className="mb-3">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
        rows={rows}
        className={`
          w-full px-3 py-1.5 text-sm border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary resize-vertical
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
        `}
        aria-describedby={error ? `${id}-error` : helpText ? `${id}-help` : undefined}
      />

      <div className="flex justify-between items-start mt-1">
        <div>
          {helpText && !error && (
            <p id={`${id}-help`} className="text-xs text-gray-500">
              {helpText}
            </p>
          )}
          {error && (
            <p id={`${id}-error`} className="text-xs text-red-600" role="alert">
              {error}
            </p>
          )}
        </div>

        {showCount && (
          <p className="text-xs text-gray-500">
            {charCount}{maxLength && ` / ${maxLength}`}
          </p>
        )}
      </div>
    </div>
  );
};

export default TextArea;